import { ConfigProvider, Menu, theme } from "antd";
import React, { useState, useEffect, createContext } from "react";
import useDarkMode from "./hooks/useDarkMode";
import Router from "./routes";

const { defaultAlgorithm, darkAlgorithm } = theme;

const BASE_THEME = {
    token: {
        borderRadius: 5,
        colorPrimary: "#5f4dee",
    },
    components: {
        Carousel: {
            dotWidth: 40,
            dotHeight: 12,
        },
        Menu: {
            itemSelectedColor: "white",
            itemSelectedBg: "#5F4DEE",
            itemHoverColor: "#FAFAFA"
        }
    },
};

const APPBOX_LIGHT_THEME = {
    algorithm: defaultAlgorithm,
    ...BASE_THEME,
};

const APPBOX_DARK_THEME = {
    algorithm: darkAlgorithm,
    ...BASE_THEME,
};

function App() {
    const [darkMode] = useDarkMode();

    return (
        <ConfigProvider theme={darkMode ? APPBOX_DARK_THEME : APPBOX_LIGHT_THEME}>
            <Router />
        </ConfigProvider>
    );
}

export default App;
